export default "__VITE_ASSET__6da08131__"